module.exports = __webpack_public_path__ + "static/media/logo-instagram.6b49b5cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-instagram.svg
// module id = 552
// module chunks = 0